import { setErrorMessage, setShowErrorMessage } from "app/system/errors/ServerErrorAlertSlice";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights } from "setup/appInsights/ApplicationInsightsService";
import { actions } from "app/modules/auth/redux/AuthRedux";
import { setShowSessionExpired } from "app/system/sessionExpired/SessionExpiredSlice";
import { CPLErrorTypes } from "cpl-react-common/Helpers/CustomErrors";
import { setErrorCode } from "app/pages/errors/ErrorHandlerSlice";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export const errorMiddleWare =
  ({ dispatch }: { dispatch: (arg0: any) => any }) =>
  (next: (arg0: { type: string }) => any) =>
  (action: { type: string; meta: any; payload: any; error?: any }) => {
    try {
      if (action.error && !action.meta.aborted) {
        let errorType = action.error.message;
        try {
          const parsed = JSON.parse(action.error.message);
          if (parsed?.message) {
            errorType = parsed.message;
          }
        } catch {
          // response body isn't JSON - compare as-is
        }

        if (errorType == CPLErrorTypes.SESSION_EXPIRED) {
          dispatch(actions.logout());
          dispatch(setShowSessionExpired(true));
        } else if (errorType == CPLErrorTypes.NOT_FOUND) {
          dispatch(setErrorCode(404));
        } else if (errorType == CPLErrorTypes.FORBIDDEN) {
          dispatch(setErrorCode(403));
        } else {
          dispatch(setErrorMessage(action.error.message));
          dispatch(setShowErrorMessage(true));
        }
        appInsights.trackException({ error: new Error(action.error), severityLevel: SeverityLevel.Error });
      }
      return next(action);
    } catch (err: any) {
      appInsights.trackException({ error: new Error(err), severityLevel: SeverityLevel.Error });
      dispatch(setErrorMessage("Something went wrong"));
      dispatch(setShowErrorMessage(true));
      throw err;
    }
  };
